import { render } from "./PurchaseView.vue?vue&type=template&id=553a0b0c&scoped=true"
import script from "./PurchaseView.vue?vue&type=script&lang=js"
export * from "./PurchaseView.vue?vue&type=script&lang=js"

import "./PurchaseView.vue?vue&type=style&index=0&id=553a0b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553a0b0c"]])

export default __exports__